<enauka-enauka-nav-bar></enauka-enauka-nav-bar>
<div class="opinions-container">
  <h1>Opinie nauczycieli</h1>
  <div class="opinion-wrapper" *ngFor="let item of wszystkie">
    <div class="opinion-inner">
      <blockquote class="p-5 opinion-quote">
        <span class="opinion-quotemark">
          <fa-icon icon="quote-right"></fa-icon>
        </span>
        <p class="mb-5 opinion-opinion">
          {{item.opinion}}
        </p>
        <span class="opinion-source">
          - {{item.source}}
        </span>
      </blockquote>
    </div>
  </div>
</div>
